import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56e5f9cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }

import TaskDescription from '@/modules/EngineRules/components/TaskDescription.vue';
    import ServiceTaskCalendar from '@/modules/EngineRules/components/ServiceTaskCalendar.vue';
    import { API } from '@/helpers/API';
    import { ref, computed, onBeforeMount } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

    const rulesList = ref([]);
    const taskDescriptionList = ref([]);
    const ready = ref(false);

    const ruleListUrl = '/engine/rules';
    const taskDescriptionListUrl = '/service-task/task-description/list/SO';

    onBeforeMount(async () => {
        await Promise.all([
            getRules(),
            getTaskDescriptions()
        ]);
    });

    const getRules = async () => {
        const pdfConfig = {
            url: ruleListUrl,
            method: 'get',
            params: {},
            responseType: 'json'
        }
        API.request(pdfConfig)
        .then((response: any) => {
            rulesList.value = response.data;
            ready.value = true;
        })
        .catch((error: any) => {
            console.error(error);
        })
    }

    const getTaskDescriptions = async () => {
        const pdfConfig = {
            url: taskDescriptionListUrl,
            method: 'get',
            params: {},
            responseType: 'json'
        }
        API.request(pdfConfig)
        .then((response: any) => {
            taskDescriptionList.value = response.data;
        })
        .catch((error: any) => {
            console.error(error);
        })
    }
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (ready.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskDescriptionList.value, (taskDescriptionDescription, taskDescriptionId) => {
              return (_openBlock(), _createBlock(TaskDescription, {
                key: taskDescriptionId,
                taskDescriptionId: Number(taskDescriptionId),
                taskDescriptionDescription: taskDescriptionDescription,
                rulesList: rulesList.value
              }, null, 8, ["taskDescriptionId", "taskDescriptionDescription", "rulesList"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ServiceTaskCalendar)
      ])
    ])
  ], 64))
}
}

})